module.exports = __webpack_public_path__ + "img/meter.d05d02c5.svg";